module.exports = __webpack_public_path__ + "static/04-protho-zoom-97a0c792f56292ec3dd2a59558847a8c.jpg";